'use client'

import { useCallback } from 'react'

import {
  DeliverySlotsByTimeOfTheDay,
  handleAddSlot,
  handleRemoveSlot,
  TMSDeliverySlotsArraySlot
} from 'modules/delivery'

interface UseSlotInteractionsParams {
  deliverySlots: DeliverySlotsByTimeOfTheDay | null
  emptyDeliverySlots: DeliverySlotsByTimeOfTheDay | null
  setSelectedDeliverySlots: (
    slotsOrUpdater:
      | TMSDeliverySlotsArraySlot[]
      | ((prevSlots: TMSDeliverySlotsArraySlot[]) => TMSDeliverySlotsArraySlot[])
  ) => void
}

/**
 * Custom hook for handling delivery slot interactions (add/remove slots)
 * Manages the logic for selecting and deselecting delivery time slots
 */
export const useSlotInteractions = ({
  deliverySlots,
  emptyDeliverySlots,
  setSelectedDeliverySlots
}: UseSlotInteractionsParams) => {
  const handleChangeDeliverySlot = useCallback(
    (value: boolean, slot?: TMSDeliverySlotsArraySlot) => {
      if (!slot) return

      const updateFunction = value
        ? handleAddSlot(slot, deliverySlots, emptyDeliverySlots)
        : handleRemoveSlot(slot)

      setSelectedDeliverySlots(updateFunction)
    },
    [deliverySlots, emptyDeliverySlots, setSelectedDeliverySlots]
  )

  return { handleChangeDeliverySlot } as const
} 